<script lang="ts" setup>
import MainMenu from '@kidzonet/dashboard-main-menu'
import { useSettingsStore } from '@kidzonet/dashboard-settings-store'
import TosAlert from '@kidzonet/dashboard-tos/src/Alert.vue'
import { addDashboardDomain, deleteDashboardDomain, getDashboardExclusionList } from '@kidzonet/ts-api-exclusion-lists'
import { useLoadLocaleMessages } from '@kidzonet/vue-i18n-package'

import Content from './Content.vue'
import ContentHeader from './Header.vue'

await useLoadLocaleMessages('dashboard_v2')

const settingsStore = useSettingsStore()
await settingsStore.fetchSettings()

globalThis.ExclusionListsApiClient = {
    getList: getDashboardExclusionList,
    create: addDashboardDomain,
    remove: deleteDashboardDomain,
}
</script>

<template>
    <div>
        <MainMenu />
        <v-main>
            <ContentHeader />
            <Content />
            <v-spacer />
            <TosAlert />
        </v-main>
    </div>
</template>

<style>
    .v-main {
        display: flex;
        flex-direction: column;
        block-size: 100vh;
        background-color: rgb(var(--v-theme-mainContentBackground));
    }
</style>
